module.exports = __webpack_public_path__ + "img/BBL.3c81e9b5.png";